import { CLEAR_CONTACT_QUOTES, FETCHING_CONTACT_QUOTES, GET_CONTACT_QUOTES } from './types'

const initialState = {
  quotes: [],
  fetching: false,
}

const quotesReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CONTACT_QUOTES:
      return { ...state, quotes: action.payload }
    case FETCHING_CONTACT_QUOTES:
      return { ...state, fetching: action.payload }
    case CLEAR_CONTACT_QUOTES:
      return { ...state, quotes: [], fetching: false }
    default:
      return state
  }
}

export default quotesReducer
